import { UserRoleEnum } from "@open-booking/shared";
import { Navigate } from "react-router";
import { AUTH_ROUTES } from "@/src/auth/constants/auth-routes";
import { getIsAuthenticated, getUser } from "@/src/auth/store/auth-selectors";
import { useAppSelector } from "@/src/common/redux/store";
import { OWNER_ROUTES } from "@/src/owner/constants/owner-routes";

export function RootRedirect() {
	const isAuthenticated = useAppSelector(getIsAuthenticated);
	const user = useAppSelector(getUser);

	if (!isAuthenticated) {
		return <Navigate to={AUTH_ROUTES.AUTH} replace />;
	}

	if (user?.role === UserRoleEnum.OWNER) {
		return <Navigate to={OWNER_ROUTES.PROPERTIES} replace />;
	}

	return <Navigate to="/account/bookings" replace />;
}
